<!-- start layout wrapper -->

<app-preloader></app-preloader>
<app-header></app-header>
<router-outlet></router-outlet>
<app-chat></app-chat>
<app-footer></app-footer>

<!-- end layout wrapper -->
